/* eslint-disable function-paren-newline */
/* eslint-disable react/require-default-props */
/* eslint-disable implicit-arrow-linebreak */

/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CommonInput, RegularButton, AlertAdapter } from 'pg-ui-library';
import { useFormik } from 'formik';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import EmployeesService from 'src/services/employees.service';
import * as yup from 'yup';
import { MFAImpersonateFormProps } from 'src/interfaces/interface MFAImpersonateFormProps ';

import { Container, ContainerButton, ContainerInsert, ContainerMessage, InfoText, MainContainer } from './styles';

export const MFAImpersonateForm: React.FC<MFAImpersonateFormProps> = props => {
  const { t } = useTranslation();
  const { config } = useTypedSelector(state => state.config.data);
  const { employee } = useTypedSelector(state => state.employees.data.selectedEmployee);

  const validationSchema = yup.object().shape({
    code: yup.string().required(t('global.form.required')).max(6),
  });

  const tryImpersonate = async (values: any) => {
    try {
      if (config?.selectedCompanyId && employee?.id) {
        const result = await EmployeesService.postImpersonationLink({
          employeeId: employee?.id,
          companyId: config?.selectedCompanyId,
          mfaCode: values?.code as unknown as string,
        });
        window.open(result.data, '_blank', 'noopener,noreferrer');
        props.setIsOpen(false);
      }
    } catch (err) {
      AlertAdapter('Impersonate was not possible', 'error');
    }
  };

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    validationSchema,
    onSubmit: async values => {
      tryImpersonate(values);
    },
  });

  return (
    <MainContainer>
      <Container onSubmit={formik.handleSubmit}>
        <ContainerMessage>
          <InfoText>{t('mfa.helpText')}</InfoText>
        </ContainerMessage>
        <ContainerInsert>
          <CommonInput
            label={t('mfa.inputLabel')}
            placeholder="Insert your MFA code"
            id="code"
            name="code"
            onChange={formik.handleChange}
            value={formik.values.code}
            maxLength={6}
          />
          <ContainerButton>
            <RegularButton style={{ width: '100%', textTransform: 'uppercase' }} type="submit">
              {t('employeePage.loginTab.accessAuth.impersonationButton')}
            </RegularButton>
          </ContainerButton>
        </ContainerInsert>
      </Container>
    </MainContainer>
  );
};
